import { useTheme, Stack, Box, Container, Typography, Paper, InputLabel, TextField, Alert, AlertTitle, Button, CircularProgress } from "@mui/material";
import { grey } from "@mui/material/colors";
import AppImg from "../../../assets/images/app.png";
import LogoImg from "../../../assets/images/logo.png";
import { ILoginUI } from "../../../types/organisms";
const LoginUI = ({
  register,
  loading,
  error,
  onSubmit
}: ILoginUI) => {
  const showMessageError = () => {
    switch (error) {
      case 0:
        return <Alert severity="error">
            <AlertTitle>
              <strong>Error de conexión</strong>
            </AlertTitle>
            Revisa la conexión de tu red
          </Alert>;
      case 1:
        return <Alert severity="error">
            <AlertTitle>
              <strong>Error de credenciales</strong>
            </AlertTitle>
            Usuario y/o Contraseña incorrecta
          </Alert>;
      default:
        return;
    }
  };
  const theme = useTheme();
  const classes = {
    root: {
      minHeight: "100vh"
    },
    banner: {
      color: "white",
      width: 0.5,
      padding: 5,
      paddingTop: 13,
      backgroundColor: theme.palette.primary.main,
      backgroundImage: "linear-gradient(to right bottom, #e75f11, #e86319, #ea681f, #eb6c25, #ec702b, #ee7531, #f07a38, #f27f3e, #f58646, #f98c4f, #fc9357, #ff995f);"
    },
    paper: {
      width: 1,
      maxWidth: 496,
      padding: 5,
      borderRadius: "24px"
    },
    inputLabel: {
      color: grey[900],
      marginBottom: 0.5
    }
  };
  return <Stack direction={"row"} sx={classes.root}>
      <Box sx={classes.banner}>
        <Container maxWidth={"sm"} disableGutters>
          <Typography variant={"h3"} fontWeight={700} marginBottom={1.5}>
            Tu plataforma de control financiero
          </Typography>
          <Typography variant="subtitle1" fontSize={"1.1rem"} marginBottom={4}>
            ► Administra clientes y pagos <br /> de manera centralizada
          </Typography>
          <Box component={"img"} src={AppImg} width={"120%"}></Box>
        </Container>
      </Box>
      <Box width={0.5}>
        <Stack alignItems={"center"} justifyContent={"center"} height={"100%"}>
          <Paper sx={classes.paper} elevation={16}>
            <Box component={"form"} noValidate onSubmit={onSubmit}>
              <Stack direction={"row"} justifyContent={"center"} marginBottom={2}>
                <Box component={"img"} src={LogoImg}></Box>
              </Stack>
              <Typography variant={"h6"} fontWeight={700} marginBottom={1} color={"secondary.dark"}>
                ¡Hola!
              </Typography>
              <Typography variant={"subtitle2"} marginBottom={3} color={grey[600]}>
                La puerta a todas nuestras herramientas esta aquí. <br />
                Inicia sesión para empezar.
              </Typography>
              <Box marginBottom={2}>
                <InputLabel htmlFor="userNameOrEmailAddress" sx={classes.inputLabel}>
                  Usuario
                </InputLabel>
                <TextField id="userNameOrEmailAddress" variant="outlined" placeholder="Ingresa tu usuario" disabled={loading} fullWidth {...register("userNameOrEmailAddress", {
                required: true
              })} />
              </Box>
              <Box marginBottom={2}>
                <InputLabel htmlFor="password" sx={classes.inputLabel}>
                  Contraseña
                </InputLabel>
                <TextField id="password" variant="outlined" placeholder="Ingresa tu contraseña" type="password" disabled={loading} fullWidth {...register("password", {
                required: true
              })} />
              </Box>
              {showMessageError()}
              <Stack direction={"row"} justifyContent={"right"} marginTop={5}>
                <Button type="submit" disableElevation={false} endIcon={loading && <CircularProgress thickness={3} size={20} sx={{
                color: "white"
              }} />}>
                  {loading ? "🕵️ Iniciando sesión" : "👉 Iniciar sesión"}
                </Button>
              </Stack>
            </Box>
          </Paper>
        </Stack>
      </Box>
    </Stack>;
};
export default LoginUI;